'use client';

import { getBotCookies } from '@repo/platform-utils/bot-cookies';
import { useAnalyticsPageView } from '../../components/PageView/Context';
import { useAnalytics } from '../../hooks/useAnalytics';
import { getCleanLocationHref } from '../../lib/urlUtils';

type TrackOptions = {
  eventId?: string;
  parentEventId?: string;
  additionalAttributes?: Record<string, unknown>;
};

export const useSegmentStandardTrack = (eventName: string, immediate = false) => {
  const { analytics, deployableName, deployableVersion, deviceId, gitSha } = useAnalytics();
  const { pageViewId, pageName, pageUrlRef } = useAnalyticsPageView();

  return (
    properties: Record<string, unknown>,
    { eventId, parentEventId, additionalAttributes }: TrackOptions = {},
  ) => {
    const { botScore, isBot, isBotUserAgent, isVerifiedBot } = getBotCookies();

    const send = immediate ? analytics?.trackNow : analytics?.track;

    return send?.(
      eventName,
      {
        deployable_name: deployableName,
        deployable_version: deployableVersion,
        pageview_id: pageViewId,
        page_name: pageName,
        page_url: pageUrlRef.current || getCleanLocationHref(),
        event_id: eventId ?? crypto.randomUUID(),
        parent_event_id: parentEventId,
        bot_management: {
          bot_score: botScore,
          is_bot: isBot,
          is_bot_user_agent: isBotUserAgent,
          is_verified_bot: isVerifiedBot,
        },
        additional_attributes: { ...additionalAttributes, traditional_device_id: deviceId },
        ...properties,
      },
      { context: { app: { name: deployableName, version: gitSha } } },
    );
  };
};
